module.exports = __webpack_public_path__ + "img/1546506115.efb32c5e.jpg";